import { useMsal } from '@azure/msal-react';

/**
 * Returns true if the user only has PEPM.Reader role (no User or Admin).
 * Readers cannot create, modify, delete, or download model files.
 */
export const useIsReader = () => {
  const { accounts } = useMsal();
  const roles = accounts[0].idTokenClaims?.roles;

  if (roles === undefined) return true;
  if (roles.includes('PEPM.Admin')) return false;
  if (roles.includes('PEPM.User')) return false;
  return true;
};
